import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { MediaWithAlbum } from '@bpm-web-app/stream-api-sdk';
import { useTrending } from '@bpm-web-app/swr-hooks';
import {
    DEFAULT_HOMEPAGE_TRACKLIST_LIMIT,
    DEFAULT_PERIOD,
    useHubSwitch,
} from '@bpm-web-app/utils';
import { useContext, useEffect, useMemo } from 'react';
import { LibraryTabsContext } from '../../../../utils/src/lib/library-tabs.context';
import { HomepageTracklistSection } from '../shared';
import { TrackListPresetSupreme } from '../shared/track-list/supreme/track-list-supreme-helpers';

interface TrendingBrowseSupremeProps {
    isDataLoaded?: boolean;
    setIsDataLoaded?: (loaded: boolean) => void;
}

export function TrendingBrowseSupreme({ isDataLoaded, setIsDataLoaded }: TrendingBrowseSupremeProps) {
    const { isDownload } = useHubSwitch();

    const { libraryProperty } = useContext(LibraryTabsContext);

    const { data, isLoading } = useTrending(isDownload ? 'download' : 'stream', {
        period: DEFAULT_PERIOD,
        limit: DEFAULT_HOMEPAGE_TRACKLIST_LIMIT,
        library: libraryProperty,
    });

    const trending = useMemo(
        () => (data?.data || []) as DownloadAlbum[] | MediaWithAlbum[],
        [data?.data]
    );

    useEffect(() => {
        if (setIsDataLoaded) {
            if (isLoading === false) {
                setIsDataLoaded(true);
            } else {
                setIsDataLoaded(false);
            }
        }
    }, [isLoading, setIsDataLoaded]);

    const shouldDisplayGhostLoading = useMemo(() => isDataLoaded === false || isLoading, [isDataLoaded, isLoading]);

    return (
        <HomepageTracklistSection
            title="Top 10"
            href="/trending"
            list={trending}
            preset={isDownload ? TrackListPresetSupreme.DownloadTrending : TrackListPresetSupreme.StreamTrending}
            isLoading={shouldDisplayGhostLoading}
            trendingStatusToShow="trending_status_weekly"
        />
    );
}

export default TrendingBrowseSupreme;
